export default "__VITE_ASSET__C0zeW0Dp__"